export default __webpack_public_path__ + "images/0x6c021ae822bea943b2e66552bde1d2696a53fbb7.png";